<template>
  <div class="chart-range">
    <div
      v-for="(item, i) in items"
      :key="i"
      class="chart-item"
    >
      <span class="chart-item-label">{{ item.label }}</span>
      <AppChartRangeBar :values="item.values" />
      <div class="d-flex align-items-center">
        <span>{{ item.values.value }} {{ item.unit }}</span>
        <i
          v-if="item.tooltip"
          v-tooltip
          :title="item.tooltip"
          class="hi hi-warning"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AppChartRangeBar from '~/components/AppChartRangeBar.vue';

export default {
  components: {
    AppChartRangeBar,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
